module.exports = __webpack_public_path__ + "assets/img/logo_yinlun.2f021922.png";